/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function ExportKPITableRequestFromJSON(json) {
    return ExportKPITableRequestFromJSONTyped(json, false);
}
export function ExportKPITableRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        expandedOnly: json['expandedOnly'],
        slicersDimensionIds: json['slicersDimensionIds'],
    };
}
export function ExportKPITableRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        expandedOnly: value.expandedOnly,
        slicersDimensionIds: value.slicersDimensionIds,
    };
}
